import { render, staticRenderFns } from "./v-input.vue?vue&type=template&id=52a17444&scoped=true&"
import script from "./v-input.vue?vue&type=script&lang=js&"
export * from "./v-input.vue?vue&type=script&lang=js&"
import style0 from "./v-input.vue?vue&type=style&index=0&id=52a17444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a17444",
  null
  
)

export default component.exports